import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
export var AppInformation = function AppInformation() {
    _classCallCheck(this, AppInformation);

    this.appId = '';
    this.appKey = '';
    this.appVersion = '';
    this.clientId = '';
    this.haierClientId = '';
    this.haierClientSecret = '';
    this.haierUserCenterUrl = '';
    this.grayMode = false;
    this.env = '';
    this.isPreViewEnv = false;
    this.platform = '';
    this.OSversion = '';
    this.idfa = '';
    this.testMode = false;
};
export var PhoneInfo = function PhoneInfo() {
    _classCallCheck(this, PhoneInfo);

    this.model = '';
};
export var ResourceInfo = function ResourceInfo() {
    _classCallCheck(this, ResourceInfo);
};